import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <main>
      <div className="page-container">
        <div className="hero">
          <h1>🎱 SwiftBreak</h1>
          <p>Lightning-Fast Pool Game for iOS</p>
          <p style={{ fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto 2rem' }}>
            Master the table with three exciting game modes, unlock achievements, 
            and compete with friends in this modern pool game experience.
          </p>
          <div className="hero-buttons">
            <a href="https://apps.apple.com" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
              Download on App Store
            </a>
            <Link to="/support" className="btn btn-secondary">
              Get Support
            </Link>
          </div>
        </div>

        <div className="features">
          <div className="feature-card">
            <div className="feature-icon">🎮</div>
            <h3>3 Game Modes</h3>
            <p>Classic, Quick Play, and Challenge mode for different play styles and skill levels.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🏆</div>
            <h3>13 Achievements</h3>
            <p>Unlock achievements as you master different skills and reach new milestones.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Detailed Stats</h3>
            <p>Track your performance with comprehensive statistics and progress tracking.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🎨</div>
            <h3>Beautiful Themes</h3>
            <p>Choose from 4 stunning table themes to customize your gaming experience.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">👥</div>
            <h3>Pass & Play</h3>
            <p>Play with friends on the same device with seamless turn-based gameplay.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🌍</div>
            <h3>7 Languages</h3>
            <p>Fully localized in English, Chinese, Japanese, German, French, Italian, and Spanish.</p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Home;
